import { ColumnKey, PartnersFormValues } from "./types";
import * as Yup from "yup";

export const apiEndpoint = `/partners`;

export const ColumnOptions: { value: ColumnKey; label: string }[] = [
  { value: "referrerID", label: "Referrer ID" },
  { value: "username", label: "Campaign Name" },
  { value: "password", label: "Password" },
  { value: "partnerProgram", label: "Partner Program" },
  { value: "partnerChannel", label: "Partner Channel" },
  { value: "partnerTitleKeys", label: "Partner Title Keys" },
  {
    value: "disableRewardedAdsForDays",
    label: "Disable Rewarded Ads For Days",
  },
  { value: "platform", label: "Platform" },
  { value: "device", label: "Device" },
  { value: "invoiceParty", label: "Invoice Party" },
  { value: "publisherID", label: "Publisher ID" },
];

export const DefaultHiddenColumns: ColumnKey[] = ["updatedAt"];

export const AllowedSortFields = [
  "username",
  "password",
  "partnerProgram",
  "partnerChannel",
  "partnerTitleKeys",
  "disableRewardedAdsForDays",
  "platform",
  "device",
  "invoiceParty",
  "publisherID",
  "createdAt",
  "updatedAt",
] as const;

export const PartnerFormInitialValues: PartnersFormValues = {
  referrerID: "" as unknown as number,
  username: "",
  password: "",
  partnerProgram: "",
  partnerChannel: "",
  partnerTitleKeys: "",
  disableRewardedAdsForDays: 0,
  platform: "",
  device: "",
  invoiceParty: null,
  publisherID: 0,
};

export const PartnerValidationSchema = Yup.object({
  referrerID: Yup.number()
    .typeError("Referrer ID must be a number")
    .positive("Referrer ID must be a positive number")
    .integer("Referrer ID must be an integer")
    .required("Referrer ID is required"),
  username: Yup.string().trim().required("Campaign Name is required"),
  partnerProgram: Yup.string()
    .typeError("Partner Program must be a string")
    .required("Partner Program is required"),
  partnerChannel: Yup.string()
    .typeError("Partner Channel must be a string")
    .required("Partner Channel is required"),
  partnerTitleKeys: Yup.string()
    .trim()
    .required("Partner Title Keys is required"),
  disableRewardedAdsForDays: Yup.number()
    .min(0, "Disable Rewarded Ads For Days cannot be negative")
    .required("Disable Rewarded Ads For Days is required"),
  platform: Yup.string().trim().required("Platform is required"),
  device: Yup.string().trim().required("Device is required"),
  invoiceParty: Yup.number()
    .typeError("Invoice Party must be a number")
    .nullable(),
  publisherID: Yup.number()
    .typeError("Publisher ID must be a number")
    .required("Publisher ID is required"),
});

export const PartnerFormFields = [
  { name: "referrerID", label: "Referrer ID", type: "number" },
  { name: "username", label: "Campaign Name", type: "text" },
  { name: "password", label: "Password", type: "password" },
  { name: "partnerProgram", label: "Partner Program", type: "text" },
  { name: "partnerChannel", label: "Partner Channel", type: "text" },
  { name: "partnerTitleKeys", label: "Partner Title Keys", type: "text" },
  {
    name: "disableRewardedAdsForDays",
    label: "Disable Rewarded Ads For Days",
    type: "number",
  },
  { name: "platform", label: "Platform", type: "text" },
  { name: "device", label: "Device", type: "text" },
  { name: "invoiceParty", label: "Invoice Party", type: "number" },
  { name: "publisherID", label: "Publisher ID", type: "number" },
];

export const programOptions = [
  { value: "0", label: "Select Program" },
  { value: "1", label: "CPL" },
  { value: "2", label: "CPC" },
  { value: "3", label: "Rev Share" },
  {
    value: "4",
    label: "Integrated partner portal",
  },
  {
    value: "5",
    label: "Weak Integrated partner portal",
  },
];
